import * as React from 'react';
import { Button, Typography, Grid2 as Grid } from '@mui/material';
import OfferItem from '../elements/offer-item';
import TestimonialCard from '../elements/testimonial-card';
import { CompetitiveAdvantages } from '../../types/blocks/competitive-advantages';
import { CallToActionButton } from '../elements/call-to-action-button';

interface SectionCompetitiveAdvantagesProps {
  element: CompetitiveAdvantages;
}

export const SectionCompetitiveAdvantages: React.FC<SectionCompetitiveAdvantagesProps> = ({
  element,
}) => (
  <div className="bg-[#CBBAF8] py-24 md:py-32 px-4 md:px-[40px] lg:px-[88px] relative">
    <div className="max-w-[1264px] mx-auto">
      <div className="space-y-16 md:space-y-24">
        <div className="text-center lg:w-[900px] mx-auto text-primary-dark">
          <Typography variant="title-mac-sans-xl" component="h3">
            {element.title}
          </Typography>
        </div>

        <div className="space-y-4 max-w-[1000px] mx-auto">
          <div className="px-6 py-10 sm:p-14 md:p-20 bg-paper rounded-3xl space-y-8">
            <Typography variant="h2" color="textPrimary" className="md:text-center mb-12 md:mb-16">
              {element.description}
            </Typography>

            <Grid container spacing={{ xs: 6, sm: 8, md: 10, lg: 13 }}>
              {element?.items.length > 0 &&
                element.items.map((item) => (
                  <Grid size={{ sm: 6 }} key={item.title}>
                    <OfferItem
                      title={item.title}
                      description={item.description}
                      imgSrc={item.icon.url}
                      imgAlt={item.title}
                    />
                  </Grid>
                ))}
            </Grid>
          </div>

          <div className="p-8 lg:p-14 bg-paper rounded-3xl overflow-hidden relative">
            <div className="relative space-y-2 mb-8 z-10">
              <Typography variant="title-mac-sans-xl" color="textPrimary" component="h3">
                {element.card.title}
              </Typography>
              <Typography
                variant="s1"
                color="textSecondary"
                component="p"
                className="leading-6 md:leading-7"
              >
                {element.card.description}
              </Typography>
            </div>
            <CallToActionButton button={element.card.callToAction} />
            <img
              src="/assets/images/homepage/three-triangle-vertical.svg"
              className="h-full w-auto absolute top-0 right-[-150px] md:right-0"
            />
          </div>
        </div>
      </div>

      <div className="pt-16 md:pt-32 relative">
        <div className="flex flex-wrap justify-center gap-1 md:gap-4 relative z-10">
          {element.trustpilotReviews.length > 0 &&
            element.trustpilotReviews.map((review) => (
              <TestimonialCard
                key={review.title}
                quote={review.title}
                name={review.user.displayName}
                platform={review.social?.toLowerCase()}
                imageUrl={review.user.avatar.url}
              />
            ))}
        </div>
      </div>
    </div>
  </div>
);
